var _style, _path, _polyline, _polyline2, _polyline3, _path2, _line, _line2, _line3, _line4, _path3, _path4, _line5, _line6, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFingerScan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 220",
    style: {
      enableBackground: "new 0 0 200 220"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#2F99F1;stroke-width:4;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.29,66c0,0,0,95.14,0,120.86S137,208.29,137,208.29s-54-0.43-76.29-0.43s-20.14-19.29-20.14-19.29 L40.14,28.43c0,0,2.14-16,19.29-16.43s79.71-0.43,79.71-0.43s19.71,1.71,20.14,14.57c0.43,12.86,0,29.14,0,29.14"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "63.29,44.57 63.29,30 78.29,30 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "119.71,30.29 135.14,30 134.86,44 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "63.71,90 63.71,104.29 78,104.29 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.86,156.57c0,0,2.86-11.43-3.43-16.86c-4-5.14-8.29-16-8.57-26.29c0.29-10.29-0.86-22.29,12.29-16.86 c0-14.86,0.29-25.14,0.29-25.14s-0.57-6.57,6.86-5.43c1.43,0.29,5.43,0,5.14,11.14l-0.29,6.57c0,0,5.14-6.57,10.57-2 c1.43,1.71,2,4,1.71,8.86c3.14-3.43,10.29-6.57,11.71,2.57c-0.29,8.86-0.29,8.86-0.29,8.86s6.57-8,12.29-0.57 c0.86,1.14,1.71,16.57,0.29,31.14"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 111.14,
    y1: 83.71,
    x2: 110.86,
    y2: 109.43
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 123.43,
    y1: 90.57,
    x2: 122.86,
    y2: 110.29
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 134.86,
    y1: 102,
    x2: 134.57,
    y2: 113.43
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 99.14,
    y1: 96.57,
    x2: 99.43,
    y2: 116.57
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.86,138c0,0-6.57,10.57-6.29,19.14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112,176c0,0,24.29,0.29,29.43,0s4.57-3.43,4.57-3.43s0.57-6,0.29-10.57c-0.29-4.57-4.86-4.29-4.86-4.29 L98,157.43c0,0-4,0.29-4,4c0,3.71-0.29,11.43-0.29,11.43s0,3.71,4.57,3.71s8.86,0,8.86,0"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 40.29,
    y1: 187.43,
    x2: 65.71,
    y2: 188
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 74,
    y1: 188.29,
    x2: 159.14,
    y2: 188
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.71,41.71c0,0,9.14-10.57,20-9.14c5.14,1.43,16,3.14,19.43,20.86c0,5.71,0.29,15.71-0.86,26.86"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.43,46.57c0,0-2,6.29-1.71,13.14S78,70.57,78,75.71c0.29,5.14,2.57,15.43,12.57,20.57"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.14,86.29c0,0-4.86-3.14-5.43-13.14c0-10.57,0.57-17.71,0.57-20c1.43-5.43,4-12,15.71-11.71 c3.71,1.43,10.86,0.57,10.57,20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94,66.57V54.86c0,0,0.29-4.86,6-5.14c3.43,0.86,5.14,1.43,4.29,10.57"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerScan);
export default __webpack_public_path__ + "static/media/finger-scan.726e47759fa6b871d1d0c4af23b5bdc0.svg";
export { ForwardRef as ReactComponent };